<template>
  <ui-component-modal
    modalTitle=""
    :buttonLabelConfirm="'Delete'"
    confirmButtonCssClass="is-danger"
    :isSaving="isDeleting"
    :isSavingSuccess="isDeletingSuccess"
    :isSavingError="isDeletingError"
    :hideFooterButtons="isDeletingError || isDeletingSuccess"
    :disableSaveButton="!isDeleteConfirmed"
    :onClickCancel="onClickCancel"
    :onClickSave="deleteImage"
    :showModal="showModal"
    @closeModal="onClickCancel"
  >
    <template slot="modalTitle"></template>
    <template v-slot:content>
      <div>
        <div class="has-margin-bottom is-size-5 has-text-centered">
          Are you sure you want to delete this image}?
        </div>
        <div class="has-text-centered">
          <BaseCheckbox
            v-model="isDeleteConfirmed"
            class="has-text-left"
            :label="'Yes, I am sure!'"
          />
        </div>
      </div>
    </template>
  </ui-component-modal>
</template>

<script>
import Vue from 'vue'
import { mapState, mapMutations } from 'vuex'
import { EventBus } from '@/eventbus/event-bus'
import spaceProvider from '@/providers/space'

const BaseCheckbox = () => import('@/components/UI/Form/BaseCheckbox')

export default {
  components: {
    BaseCheckbox,
  },

  props: {
    image: {
      type: Object,
      default: null,
    },

    showModal: {
      type: Boolean,
      default: false,
    },

    onClickCancel: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      isDeleteConfirmed: false,
      isDeleting: false,
      isDeletingSuccess: false,
      isDeletingError: false,
      mSpace: null,
    }
  },

  computed: {
    ...mapState('spaceStore', ['space']),
  },

  created() {
    this.mSpace = JSON.parse(JSON.stringify(this.space))
  },

  methods: {
    ...mapMutations('spaceStore', ['setSpace']),

    deleteImage() {
      if (!this.isDeleting) {
        let self = this
        self.isDeleting = true
        self.isDeletingSuccess = false
        self.isDeletingError = false

        spaceProvider.methods
          .deleteSpaceImageById(self.mSpace.Id, self.image.Id)
          .then((response) => {
            if (response.status === 204) {
              self.isDeletingSuccess = true

              let imageIndex = self.mSpace.Images.findIndex(
                (i) => i.Id === self.image.Id
              )
              //console.info(imageIndex)
              if (imageIndex > -1) {
                self.mSpace.Images.splice(imageIndex, 1)
              }

              self.setSpace(self.mSpace)

              setTimeout(() => {
                self.onClickCancel()
              }, 1500)
            }
          })
          .catch((error) => {
            //console.log(error.response)
            self.isDeletingError = true
          })
          .finally(() => {
            self.isDeleting = false
          })
      }
    },
  },
}
</script>
